function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var transitionId = 0;
export function getTransitionId() {
  return ++transitionId;
}
export function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }
}
export function once(func) {
  var called = false;
  return function transitionEvent() {
    if (!called) {
      called = true;
      func.call(this);
    }
  };
}
export function isNamespace(prop) {
  return _typeof(prop) === 'object' && Array.isArray(prop) === false;
}

var linear = function linear(t) {
  return +t;
};

export var timingDefaults = {
  delay: 0,
  duration: 250,
  ease: linear
};


//////////////////
// WEBPACK FOOTER
// ./~/kapellmeister/es/utils.js
// module id = 557
// module chunks = 0